module.exports = __webpack_public_path__ + "img/icon_Scratch.b1e0d4cd.png";